export async function loadLocale(locale: string) {
  switch (locale) {
    case "en":
      return await import(`../locales/en/zod`);
    case "es":
      return await import(`../locales/es/zod`);
    default:
      return await import(`../locales/en/zod`);
  }
}
